import { apiAxios } from "./api-config/apiConfig";

/* =======================
   LIST API
======================= */

export interface ReportItem {
  id: string;
  name: string;
  sortOrder: number;
  reportId: string;
  submittedDate: string;
}

export interface ReportListResponse {
  status: boolean;
  data: ReportItem[];
}

export const getReportList = async (): Promise<ReportListResponse> => {
  const response = await apiAxios.get<ReportListResponse>("/report/list");
  return response.data;
};

/* =======================
   DETAILS API
======================= */

export interface ReportOption {
  optionId: string;
  optionName: string;
  optionSortOrder: number;
}

export interface ReportQuestion {
  questionId: string;
  questionName: string;
  questionDesc: string;
  questionSortOrder: number;
  answer: string | null;
  options?: ReportOption[];
}

export interface ReportCategory {
  id: string;
  name: string;
  sortOrder: number;
  questions: ReportQuestion[];
}

export interface ReportDetailsData {
  id: string;
  weekReportMappingId: string;
  reportDetails: Array<ReportCategory | ReportQuestion>;
  createdAt: string;
  updatedAt: string;
  reports: {
    weekId: string;
    weeks: {
      name: string;
    };
  };
}

export interface ReportDetailsResponse {
  status: boolean;
  data: ReportDetailsData;
}

export const getReportById = async (
  id: string,
): Promise<ReportDetailsResponse> => {
  const response = await apiAxios.get<ReportDetailsResponse>(`/report/${id}`);
  return response.data;
};
